(() => {
  'use strict';

  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const visibleFocusable = container =>
    Array.from(container?.querySelectorAll(FOCUSABLE) || []).filter(el =>
      !el.hidden &&
      el.getAttribute('aria-hidden') !== 'true' &&
      (el.offsetWidth || el.offsetHeight || el.getClientRects().length)
    );

  const focusFirst = container => {
    const first = visibleFocusable(container)[0];
    if (first) first.focus({ preventScroll: true });
    return first;
  };

  const visibleName = element => String(element?.innerText || element?.textContent || '').replace(/\s+/g, ' ').trim();

  const repairInjectedAccessibility = root => {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('iframe:not([title])').forEach(frame => {
      if (frame.id === 'merchantwidgetiframe') frame.title = 'Google customer reviews';
      else if (frame.id === 'PBarNextFrame') frame.title = 'Shopify theme preview controls';
    });

    scope.querySelectorAll('.ts-dropdown-btn[aria-label], #chizy-v2-split-shell[aria-label]').forEach(control => {
      const name = visibleName(control);
      if (name) control.setAttribute('aria-label', name);
    });
  };

  repairInjectedAccessibility(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) repairInjectedAccessibility(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  let filterOpener = null;

  const getOpenFilter = () =>
    Array.from(document.querySelectorAll('[data-abm-filters]')).find(el => el.classList.contains('is-open'));

  const syncTargetStatus = root => {
    (root || document).querySelectorAll('[data-abmium-target-status]').forEach(status => {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
    });
  };

  const prepareFilterDialog = drawer => {
    if (!drawer) return;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    const close = drawer.querySelector('[data-abm-close-filters]');
    if (close) close.focus({ preventScroll: true });
    else focusFirst(drawer);
  };

  const releaseFilterDialog = drawer => {
    if (drawer) {
      drawer.removeAttribute('role');
      drawer.removeAttribute('aria-modal');
    }
    if (filterOpener?.isConnected) filterOpener.focus({ preventScroll: true });
    filterOpener = null;
  };

  document.addEventListener('mobile-menu:open', () => {
    requestAnimationFrame(() => {
      const mobile = document.querySelector('.mobile-menu, .mobile-menu-wrapper, [data-mobile-menu]');
      if (mobile) focusFirst(mobile);
    });
  });

  document.addEventListener('click', event => {
    const open = event.target.closest?.('[data-abm-open-filters]');
    if (open) {
      filterOpener = open;
      requestAnimationFrame(() => prepareFilterDialog(getOpenFilter() || document.querySelector('[data-abm-filters]')));
      return;
    }

    const close = event.target.closest?.('[data-abm-close-filters]');
    if (close) {
      const drawer = close.closest('[data-abm-filters]');
      requestAnimationFrame(() => releaseFilterDialog(drawer));
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (document.body.classList.contains('mobile-menu-open')) {
        const toggle = document.querySelector('.head-slot-nav-mobile-link[aria-expanded="true"], .head-slot-nav-mobile-link');
        if (toggle) {
          event.preventDefault();
          toggle.click();
          return;
        }
      }

      const drawer = getOpenFilter();
      if (drawer) {
        event.preventDefault();
        const close = drawer.querySelector('[data-abm-close-filters]');
        if (close) close.click();
        else {
          drawer.classList.remove('is-open');
          releaseFilterDialog(drawer);
        }
        return;
      }
    }

    if (event.key === 'Tab' && window.matchMedia('(max-width: 989px)').matches) {
      const drawer = getOpenFilter();
      if (!drawer) return;
      const items = visibleFocusable(drawer);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];

      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  const navToggle = document.querySelector('.button-main-nav-toggle');
  if (navToggle) {
    const syncLabel = () => {
      navToggle.setAttribute(
        'aria-label',
        navToggle.getAttribute('aria-expanded') === 'true' ? 'Collapse navigation' : 'Expand navigation'
      );
    };
    syncLabel();
    new MutationObserver(syncLabel).observe(navToggle, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }

  const actions = document.querySelector('.abm-header-actions[aria-label]');
  if (actions && !actions.hasAttribute('role')) actions.setAttribute('role', 'navigation');

  const availability = document.querySelector('.abm-buy__availability');
  if (availability) {
    availability.setAttribute('role', 'status');
    availability.setAttribute('aria-live', 'polite');
    availability.setAttribute('aria-atomic', 'true');
  }

  syncTargetStatus(document);
  document.addEventListener('abmium:target-catalogue-ready', event => {
    syncTargetStatus(event.detail?.root || document);
  });
})();
